export const ContactUsDataLoaded = (data,persons) => ({
    type: !persons ? 'CONTACT_US_DATA_LOADED_FORMS' : 'CONTACT_US_DATA_LOADED_PERSONS',
    payload : data
})
